import { SET_FEATURE } from '@redux/constants';
import makeReducer from '../../utils/fabrickReducer';

const initialState = {
  
};

export default makeReducer(initialState, SET_FEATURE);
